import { useGetFormationThematicsMutation } from '@services';
import { useEffect, useState } from 'react';
import { FormationCategory } from '@services';

export const useFormationListPageVM = () => {
    const [categories, setCategories] = useState<FormationCategory[]>([]);
    const [getFormationThematics, { isLoading, data, error }] = useGetFormationThematicsMutation();

    useEffect(() => {
        getFormationThematics(undefined);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (data) {
            setCategories(data);
        }
    }, [data]);

    return {
        categories,
        isLoading,
        error
    };
};
